import React, { useState } from "react";
import { axiosPost } from "../../utils/AxiosApi";
import { URL } from "../../utils/Constants";
import swal from "sweetalert";
import { Spinner } from "reactstrap";


const RegistrationNumberModal = ({
  student,
  setRegistrationNumberModal,
  refetchStudents,
}) => {
  const [loading, setLoading] = useState(false);
  const [registrationNumber, setRegistrationNumber] = useState(
    student?.registrationNumber ?? "",
  );

  const handleRegistrationumberSubmit = (e) => {
    e.preventDefault();

    const params = {
      admissionId: student?.admissionId,
      registrationNumber: registrationNumber,
    };

    if (!registrationNumber.trim()) {
      setLoading(true);
      axiosPost(
        URL.deleteRegistrationNumber,
        params,
        (response) => {
          if (response.status === 200) {
            setRegistrationNumberModal(false);
            swal("Success", "Registration Number deleted successfully");
            setLoading(false);
            refetchStudents();
          }
        },
        (error) => {
          swal(
            "Oops",
            error.response.data.message ||
              "Failed to delete registration number",
          );
          setLoading(false);
        },
      );
      return;
    }

    if (registrationNumber === student?.registrationNumber) {
      return;
    }

    setLoading(true);
    axiosPost(
      URL.insertRegistrationNumber,
      params,
      (response) => {
        if (response.status === 200) {
          setRegistrationNumberModal(false);
          swal("Success", "Registration Number updated successfully");
          setLoading(false);
          refetchStudents();
        }
      },
      (error) => {
        swal(
          "Oops",
          error.response.data.message || "Failed to update registration number",
        );
        setLoading(false);
      },
    );
  };

  return (
    <form className="std-details-form" onSubmit={handleRegistrationumberSubmit}>
      <div className="student-input">
        <label htmlFor="registration-number">Registration Number</label>
        <input
          type="text"
          name="registration-number"
          id="registration-number"
          value={registrationNumber}
          onChange={(e) => setRegistrationNumber(e.target.value)}
        />
      </div>
      <button
        className="primary-btn student-form-btn"
        disabled={loading}
        type="submit"
      >
        {loading ? (
          <Spinner size={"sm"} color="white" />
        ) : (
          "Update Registration Number"
        )}
      </button>
    </form>
  );
};

export default RegistrationNumberModal;
